import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrowserRouter } from 'react-router-dom'
import { hydrate, render } from "react-dom";


const root = document.getElementById('root');
//ReactDOM.createRoot()
// root.render(
//   <BrowserRouter>
//   <ChakraProvider>
//     <App />
//   </ChakraProvider>
//   </BrowserRouter>

// );

if (root.hasChildNodes()) {
  hydrate(
    <BrowserRouter>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </BrowserRouter>
    , root);
} else {
  render(
<BrowserRouter>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </BrowserRouter>
    
    , root);
}